import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import SelectElementCmp from '@/utils/SelectElementCmp';
import ClientsAreaApiService from '@/modules/clients/services/ClientsAreaApiService';
import {TermFilter} from '@dofleini/query-builder';
import {map} from 'lodash';
import {useGetAllFacilitiesUser} from '@/modules/clients/hooks/useArea';


const SelectUserFacilities = ({ value, onChange, translation, setAreas, areas, user, ...props }) => {

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v?._id || v) : undefined;
  }, [value]);

  const additionalParams = useMemo(() => ({
    forceSize: true,
    size: 1000,
    useProjections: true,
    projections: {
      name: 1,
    }
  }), []);

  const handleOnChange = useCallback((value) => {
    onChange(value);
  }, [onChange]);

  const setEntities = useCallback((entities) => {
    if ((!areas || areas?.length === 0) && entities?.length > 0) {
      setAreas(entities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SelectElementCmp
      queryKey={'user-facilities-selection'}
      service={ClientsAreaApiService}
      customMethod={'/ms-core/api/areas/search-space'}
      includeValue={''}
      value={currentValue}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      mode="multiple"
      nameToShow={'name'}
      additionalParams={additionalParams}
      placeholder={!user ? translation('placeholderSelectServices') : '-'}
      afterLoadData={setEntities}
      {...props}
    />
  );
};

SelectUserFacilities.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  setAreas: PropTypes.number,
  areas: PropTypes.array,
  setAreasValues: PropTypes.func,
  translation: PropTypes.func,
  user: PropTypes.string
};
SelectUserFacilities.defaultProps = {
  entity: {},
};

export default memo(SelectUserFacilities);

const UserFacilitiesView = ({value}) => {

  const filter = useMemo(() => {
    return new TermFilter({field: '_id', value: { $in: value } }).toQuery();
  }, [value]);

  const {data} = useGetAllFacilitiesUser(filter);

  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={`tag-${item['_id']}`} className="pb-2">
          <Tag className="px-2 py-1">
            {item['name']}
          </Tag>
        </div>
      ))}
    </div>);
  }, []);

  return (
    <>
      {tagsRender(data|| [])}
    </>
  );
};

UserFacilitiesView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * */
export const renderUserFacilities = (value) => {

  return (
    <UserFacilitiesView value={value}/>
  );
};
